/* eslint-disable import/prefer-default-export,no-nested-ternary,eqeqeq,no-param-reassign,array-callback-return */
import { PlaceHolderMode } from '../../../../../../../../../slide/domain/ui-model/element-modeles/property/placeholder/PlaceHolderMode';
import _cloneDeep from 'lodash/cloneDeep';
import { getFrameAfterFlipH } from '@src/slide/infrastructure/module/independent/graphic';
import { advHas } from '@src/slide/infrastructure/module/independent/assert/get-set';
import _has from 'lodash/has';
import { RenderPostionType } from '@src/js/constant';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { MasterPlaceHolderDefaultItems, PlaceHolderDefaultItems } from '@editor/src/js/constants/place-holder-default-data';
import { toJS } from 'mobx';
import { deepCopy } from '@src/slide/infrastructure/module/independent/object-operation';
import { PlaceholderConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/placeholder/placeholder-converter';

const isUnSupportPlaceHolder = type => (type === PlaceHolderMode.NONE
        || type === PlaceHolderMode.CHART
        || type === PlaceHolderMode.DGM
        || type === PlaceHolderMode.MEDIA
        || type === PlaceHolderMode.CLIPART);

const afterFlipTextRect = (textRect, flipStyle, center) => {
    let rect = _cloneDeep(textRect);
    if (flipStyle && (flipStyle.flipH === 1 || flipStyle.flipV === 1)) {
        rect = getFrameAfterFlipH(rect, center); // 这里由于文本区域垂直翻转的时候既水平又垂直翻转了，所以逻辑看起来奇怪，但是是对的。。
    }
    return rect;
};

const getEditorEnterFocus = component => advHas(component, 'editorEnterFocus') && component.editorEnterFocus;

const getPlaceHolderUnsupport = component => component?.placeHolder?.type
    && isUnSupportPlaceHolder(component.placeHolder.type);

const getIsCustomPlaceholder = component => (component?.isCustomPlaceholder
    ? component.isCustomPlaceholder : false); // 是否是通过placeholder创建的shape

const getHasCustomPrompt = component => PlaceholderConverter.convertCustomPrompt(component); // 是否是修改了默认文案的placeholder

const hasNoTextInPara = p0 => p0.textRuns.length === 1 && (!p0.textRuns[0].text || p0.textRuns[0].text === '\uFEFF');

const judgeTextIsEmpty = (paragraphList) => {
    if (!paragraphList) return true;
    const p = toJS(paragraphList);
    if (!p) return true;
    if (!p.length) return true;
    if (p.length === 1) {
        if (!p[0].textRuns?.length) return true;
        if (hasNoTextInPara(p[0])) return true;
    }
    return false;
};

const isTextSomeAsDefault = (paragraphList, type) => {
    if (paragraphList?.length < 1) {
        return false;
    }
    // 目前判断文字相同只比较第一段文字
    const textRuns = paragraphList[0].textRuns ?? [];
    const allText: string = textRuns.reduce((pre, cur) => String(cur.text) + pre, '');
    if (allText === MasterPlaceHolderDefaultItems[type]?.text || '') {
        return true;
    }
    return false;
};

const isPlaceHolderShow = (
    isCustomPlaceholder,
    editorFocus,
    component,
    hasCustomPrompt,
    isPlaceHolder,
    region,
) => {
    // placeholder判断逻辑 优先判断是不是ph添加的element，不是的话判断editor是否显示，editor显示时如果文本不为空要看用户是否修改了ph默认文案
    const placeHolderShouldNotShow = isCustomPlaceholder // 已经转化成别的元素了
        || editorFocus // 文本进入编辑态
        || (!judgeTextIsEmpty(component.paragraphList) && !hasCustomPrompt); // 非空且不是母版修改文案
    return (isPlaceHolder && region === RenderPostionType.TEMPLATE)
        || (isPlaceHolder && !placeHolderShouldNotShow);
};

const getUnEditable = (placeHolderShow, editable, region) => placeHolderShow && !editable
    && region !== RenderPostionType.TEMPLATE;

const getLeftScale = (unEditable, fromScale, isPlaceHolder, isCustomPlaceholder, region) => unEditable
    || ((fromScale === 1)
        && isPlaceHolder
        && !isCustomPlaceholder
        && region !== RenderPostionType.TEMPLATE);


const getControlValues = (component, componentProps) => (component.operatingGraphicInfo
    ? component.operatingGraphicInfo.controlValues
    : componentProps.style.controlValues);

const getPathList = component => (component.operatingGraphicInfo?.pathList?.length > 0
    ? component.operatingGraphicInfo.pathList
    : component.props.style.pathList);

const updateBgImageSrcRect = (componentProps, rect) => {
    if (componentProps.style.fillBackground?.image) {
        // eslint-disable-next-line no-nested-ternary
        let srcRect = (rect?.srcRect)
            ? rect.srcRect
            : componentProps.style.fillBackground.image.stretch
                ? componentProps.style.fillBackground.image.stretch.fillRect
                : null;
        if (srcRect) {
            srcRect = {
                ...srcRect,
            };
            if (!(srcRect.l)) srcRect.l = 0;
            if (!(srcRect.r)) srcRect.r = 0;
            if (!(srcRect.t)) srcRect.t = 0;
            if (!(srcRect.b)) srcRect.b = 0;
        }
    }
};

const getSize = (rect, componentProps) => ({
    width: rect ? rect.width : componentProps.style.width,
    height: rect ? rect.height : componentProps.style.height,
    left: rect ? rect.left : componentProps.style.left,
    top: rect ? rect.top : componentProps.style.top,
});

const getFlip = (rect, componentProps) => ({
    flipH: rect ? rect.flipH : (_has(componentProps, 'style.flipH') ? componentProps.style.flipH : 0),
    flipV: rect ? rect.flipV : (_has(componentProps, 'style.flipV') ? componentProps.style.flipV : 0),
});

const getEditable = (isCroping, editable) => ((browser.isMobile || isCroping) ? false : editable);

const getPointerEvents = (isCroping, component) => (isCroping || !component.selectable ? 'none' : null);

// 单独插入图片或表格
const isOnlyPicOrTbl = type => type === PlaceHolderMode.TBL || type === PlaceHolderMode.PIC;

// 可以插入图片或表格
const isPicOrTbl = type => isOnlyPicOrTbl(type) || type === PlaceHolderMode.TXT;

const getPlaceHolderType = (component) => {
    let type = PlaceHolderMode.TXT;
    if (component?.placeHolder?.type !== undefined) {
        // eslint-disable-next-line prefer-destructuring
        type = component.placeHolder.type;
    }

    // 移动端屏蔽掉表格/图片的占位符
    if (browser.isMobile) {
        if (type === PlaceHolderMode.TXT) {
            type = PlaceHolderMode.BODY;
        }
        if (type === PlaceHolderMode.PIC || type === PlaceHolderMode.TBL) {
            type = PlaceHolderMode.NONE;
        }
    }
    return type;
};

const getText = (type, isFromMaster: boolean) => {
    let text = '';
    if (isFromMaster) {
        text = MasterPlaceHolderDefaultItems[type]?.text || '';
    } else if (_has(PlaceHolderDefaultItems, type)) {
        // eslint-disable-next-line prefer-destructuring
        text = PlaceHolderDefaultItems[type].text;
    }
    return text;
};

const clear = (myPHL, hasText, type?: string, isFromMaster?: boolean) => {
    if (myPHL?.length > 0) {
        myPHL.map((curItem) => {
            curItem.textRuns = [];
        });
    } else {
        myPHL = [{
            textRuns: [],
        }];
    }
    if (hasText) {
        // 有文字的话再添加 textRuns，没有文字的话就保持 textRun 为空，和非 placeholder 的文本框逻辑保持一致
        const text = getText(type, !!isFromMaster);
        myPHL[0].textRuns[0] = {
            text,
            styles: {},
        };
    }
    myPHL[0].paragraphProps =  _has(myPHL[0], 'paragraphProps')
        ? myPHL[0].paragraphProps
        : {};

    return myPHL;
};

const initTextRun = (component) => {
    const type = getPlaceHolderType(component);
    const hasCustomPrompt = getHasCustomPrompt(component);
    let paragraphList = deepCopy(component.paragraphList);
    if (component.isFromSlide) {
        // 2.0编辑区的占位符是sdk直接组装好paragraphList或者攒出来一个空的在外层merge styleList的样式
        // 3.0则改成自行在layout上textRun文本，其余样式则在外层拿（因为编辑区可能更新占位符样式，所以外层是最全的）
        const layoutParagraphList = PlaceholderConverter.convertCustomPromptParagraphList(component).slice(0, 1);
        if (paragraphList.length && layoutParagraphList.length) {
            if (!paragraphList[0].textRuns?.length) {
                paragraphList[0].textRuns = layoutParagraphList[0].textRuns;
            }
        }
    }
    if (hasCustomPrompt === 1 && !judgeTextIsEmpty(paragraphList)) {
        component.customPrompt = paragraphList;
        return paragraphList;
    }
    if (hasCustomPrompt === 1 && _has(component, 'customPrompt')) {
        paragraphList = component.customPrompt;
        return paragraphList;
    }
    return clear(paragraphList, true, type, !component.isFromSlide);
};

export {
    isUnSupportPlaceHolder,
    afterFlipTextRect,
    getEditorEnterFocus,
    getPlaceHolderUnsupport,
    getIsCustomPlaceholder,
    getHasCustomPrompt,
    isPlaceHolderShow,
    getUnEditable,
    getLeftScale,
    getControlValues,
    updateBgImageSrcRect,
    getSize,
    getFlip,
    getEditable,
    getPointerEvents,
    isPicOrTbl,
    isOnlyPicOrTbl,
    isTextSomeAsDefault,
    initTextRun,
    getPlaceHolderType,
    judgeTextIsEmpty,
    clear,
    getText,
    getPathList,
};
